type ErrorResponse = {
  message: string;
  error: string;
};
export class RequestBuilder {
  protected baseURL: string = '';
  protected init: RequestInit = {};
  protected url: string = '';
  protected urlParams: string = '';

  public constructor(baseURL: string = '') {
    this.baseURL = baseURL;
  }

  /**
   * Initializes a new request by resetting the instance properties.
   *
   * @returns The current instance of the RequestBuilder.
   */
  public createRequest(): this {
    this.init = {};
    this.url = '';
    this.urlParams = '';

    return this;
  }

  public setMethod(method: 'POST' | 'GET' | 'DELETE' | 'PUT'): this {
    this.init.method = method;

    return this;
  }

  public setBody(body: BodyInit): this {
    this.init.body = body;

    return this;
  }

  public setHeader(name: string, value: string): this {
    const headers = (this.init.headers || new Headers()) as Headers;

    headers.set(name, value);

    this.init.headers = headers;

    return this;
  }

  public setURL(url: string): this {
    this.url = url;

    return this;
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  public setURLParams(params: Record<string, any>): this {
    for (const [key, value] of Object.entries(params)) {
      if (typeof value !== 'string') {
        params[key] = JSON.stringify(value);
      }
    }

    this.urlParams = '?' + new URLSearchParams(params).toString();

    return this;
  }

  /**
   * Executes the request.
   *
   * @throws An error message from the backend.
   */
  public async execute(): Promise<unknown> {
    const response = await fetch(this.baseURL + this.url + this.urlParams, this.init);

    const content = await response.text();

    const json = JSON.parse(content);

    if (response.ok) {
      return json;
    }

    const errorResp = json as ErrorResponse;
    const error = new Error(
      errorResp.message ??
        errorResp.error ??
        Object.values(errorResp)[0] ??
        JSON.stringify(errorResp),
    );
    error.name = 'CustomError';
    throw error;
  }
}
